// Maps text sizes to pixel values
// If sizes differ by screen size, create a map for the screen size and its associated pixel value
// Used for body copy and CTAs
var BodySize = new Map();
BodySize.set(1, 14);
BodySize.set(2, 16);
export var getBodySize = function (_a) {
    var size = _a.size;
    return BodySize.get(size);
};
export default {};
